import { render, staticRenderFns } from "./PsHomeIndicators.vue?vue&type=template&id=0ebf2f88&scoped=true&"
import script from "./PsHomeIndicators.vue?vue&type=script&lang=js&"
export * from "./PsHomeIndicators.vue?vue&type=script&lang=js&"
import style0 from "./PsHomeIndicators.vue?vue&type=style&index=0&id=0ebf2f88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebf2f88",
  null
  
)

export default component.exports